const DefaultGroupInput = () => null;

export default DefaultGroupInput;
